module.exports = "/_next/static/images/tools-1-88724e81dc0becf73059b654c5e018b9.png";